import React from 'react';
import { ChatInterface } from './ChatInterface';

interface ChatContainerProps {
  channelIdFromUrl?: string | null;
  prefillText?: string;
  iceBreaker?: { matchId: string; index: number };
}

export const ChatContainer: React.FC<ChatContainerProps> = React.memo(
  ({ channelIdFromUrl, prefillText, iceBreaker }) => {
    return (
      <div className='w-full h-full flex rounded-lg bg-white'>
        <ChatInterface
          channelIdFromUrl={channelIdFromUrl}
          prefillText={prefillText}
          iceBreaker={iceBreaker}
        />
      </div>
    );
  }
);

ChatContainer.displayName = 'ChatContainer';
